import { render, staticRenderFns } from "./add_questionnaire.vue?vue&type=template&id=79748b14&scoped=true"
import script from "./add_questionnaire.vue?vue&type=script&lang=js"
export * from "./add_questionnaire.vue?vue&type=script&lang=js"
import style0 from "./add_questionnaire.vue?vue&type=style&index=0&id=79748b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79748b14",
  null
  
)

export default component.exports